import LoadingIndicator from "@common/components/LoadingIndicator";
import { Typography } from "@earned/core";
import { useFinancialPlanSummaryValues } from "@modules/financialplan/hooks";

const FinancialPlanSummary = () => {
  const { currentMarketValue, excessAtPlansEnd, isLoading } =
    useFinancialPlanSummaryValues();
  return (
    <>
      <LoadingIndicator isVisible={isLoading} />
      {!isLoading && (
        <div className="flex flex-col p-10 pt-0">
          <div className="flex flex-col md:flex-row">
            <div className="flex h-20 flex-col gap-2 border-primary pr-5 md:border-r">
              <Typography variant="title-2xl" color="primary" weight="medium">
                {currentMarketValue}
              </Typography>
              <Typography variant="body" color="secondary">
                Current value of retirement net assets
              </Typography>
            </div>
            <div className="hidden h-20 min-w-[10rem] flex-col justify-end gap-2 border-r border-primary px-5 md:flex">
              <Typography variant="title-md" color="primary" weight="medium">
                {excessAtPlansEnd}
              </Typography>

              <Typography variant="body" color="secondary">
                Excess at plan&apos;s end
              </Typography>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FinancialPlanSummary;
